/**
 * @author Martin Albarracin
 * @file index.js
 * @description Video Calls Container
 */

// Dependencies
import React from 'react';

// Components
import AppRoutes from '@nephro/components/AppRoutes';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Routes
import routes from './routes';

/**
 * Video Calls Container.
 * @return { Node } React Video calls container.
 */
const VideoCallsContainer = () => {
  return (
    <AppCardLayout>
      <AppRoutes routes={routes} />
    </AppCardLayout>
  );
};

/**
 * @name VideoCallsContainer.propTypes
 * @type { Object }
 */
VideoCallsContainer.propTypes = {};

/**
 * Default props
 */
VideoCallsContainer.defaultProps = {};

export default VideoCallsContainer;
